import { GetProps } from 'antd';
import AntPhoneInput from 'antd-phone-input';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { getCountry } from 'react-phone-hooks';

import { FormInput, FormInputProps } from '../FormInput/FormInput';

import './InputPhone.scss';

type PhoneInputProps = GetProps<typeof AntPhoneInput>;
type InputPhoneProps = { deleteField?: React.ReactNode };
export type PhoneInputOwnProps = PhoneInputProps & FormInputProps & InputPhoneProps;

const MAX_LENGTH_FOR_UKRAINE_PHONE_NUMBER = 19;
const UKRAINE_PHONE_PATTERN = '+380 (..) ... .. ..';

const ukraineMetadata = getCountry('ua' as Parameters<typeof getCountry>[0]);
if (ukraineMetadata) {
  ukraineMetadata[3] = UKRAINE_PHONE_PATTERN;
}

export const InputPhone = React.forwardRef<any, PhoneInputOwnProps>(
  (
    {
      disabled = false,
      name,
      label = 'Номер телефону',
      onChange,
      onBlur,
      value,
      onlyCountries = ['ua'],
      excludeCountries = [],
      preferredCountries = ['ua'],
      errorMessage,
      className,
      required,
      deleteField,
      ...props
    },
    ref,
  ) => {
    const [localValue, setLocalValue] = useState(value);
    const [isFocused, setIsFocused] = useState(false);
    const [country, setCountry] = useState('ua');
    const [hasValueChanged, setHasValueChanged] = useState(false);
    const selectButtonToggler = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (!isFocused && value !== localValue) {
        setLocalValue(value);
        setHasValueChanged(true);
      }
    }, [value, isFocused, localValue]);

    return (
      <FormInput label={label} required={required} errorMessage={errorMessage}>
        <AntPhoneInput
          ref={ref}
          key={String(hasValueChanged)}
          {...props}
          inputMode="tel"
          data-testid="phone-input"
          enableArrow
          name={name}
          value={localValue}
          preferredCountries={preferredCountries}
          className={classNames('ant-phone-input', { 'ant-phone-input--error': !!errorMessage }, className)}
          onFocus={(): void => setIsFocused(true)}
          onBlur={(event): void => {
            setIsFocused(false);
            setLocalValue(value);
            onBlur?.(event);
          }}
          onChange={(phoneValue, event): void => {
            if (phoneValue.isoCode) {
              setCountry(phoneValue.isoCode);
            }
            const newValue = phoneValue
              ? phoneValue.countryCode + (phoneValue.areaCode || '') + (phoneValue.phoneNumber || '')
              : '';
            setLocalValue(newValue);
            onChange && onChange(phoneValue, event);
          }}
          disabled={disabled}
          maxLength={country === 'ua' ? MAX_LENGTH_FOR_UKRAINE_PHONE_NUMBER : undefined}
          onlyCountries={onlyCountries}
          excludeCountries={excludeCountries}
          dropdownRender={(menu): React.ReactNode => (
            <div className="dropdown-button" ref={selectButtonToggler} role="button" tabIndex={0}>
              {menu}
              <div className="dropdown-button__divider" />
            </div>
          )}
        />
        {deleteField && deleteField}
      </FormInput>
    );
  },
);
